import { Routes, Route, useLocation, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Container from '@mui/material/Container';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Header } from './components';
import { Qr, Login, Sms, Register, ForgotPassword } from './pages';
import { selectIsAuth } from './redux/slices/auth';
import statImg from './img/logoData.png';
import { IinProvider } from './context/IinContext';

function App() {
  const dispatch = useDispatch();
  const isAuth = useSelector(selectIsAuth);
  const location = useLocation();
  const { t } = useTranslation(); 

  return (
    <IinProvider>
      <Header />
      <Container maxWidth="lg"> 
        <Link to="/">
          <img style={{ width: "72px", height: "80px", display: "block", marginInline: "auto" }} src={statImg} alt="" />
        </Link>
        <h2 style={{ textAlign: "center"}}>
          {location.pathname === '/register' ? '' : t('app.portalLoginTitle')}
        </h2>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/digital-signature" element={<Login />} />
          <Route path="/qr" element={<Qr />} />
          <Route path="/sms" element={<Sms />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />}/>
        </Routes>
      </Container>
    </IinProvider>
  );
}

export default App;